import React from "react";

type NavbarLinksWrapperProps = React.ComponentProps<"div">;

export const NavbarLinksWrapper = ({ children }: NavbarLinksWrapperProps) => {
  return <div className="flex space-x-6">{children}</div>;
};
